import { render, staticRenderFns } from "./content-hub-drawer.vue?vue&type=template&id=5716fcca&scoped=true&"
import script from "./content-hub-drawer.vue?vue&type=script&lang=js&"
export * from "./content-hub-drawer.vue?vue&type=script&lang=js&"
import style0 from "./content-hub-drawer.vue?vue&type=style&index=0&id=5716fcca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716fcca",
  null
  
)

export default component.exports